<template>
  <a :href="shopUrl">
    <div class="shop">
      <div class="logo">
        <img :src="shop.logoUrl">
      </div>
      <div class="info">
        <p class="van-ellipsis">{{ shop.shopName }}</p>
        <div class="desc">
          <stars :value="shop.avgScore" :size="20" />
          <span> {{ shop.evaluationCount }}条评价</span>
          <span class="distance">{{ distance }}</span>
        </div>
        <div class="credit">
          <span class="grey">口碑值:&nbsp;&nbsp;{{ shop.shopCredit }}</span>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import Stars from './Stars.vue';
import Util from '../lib/util';

export default {
  name: 'ShopListItem',
  components: {
    Stars,
  },
  props: {
    shop: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    shopUrl() {
      return `${globalRootUrl}shop/${this.shop.shopId}/`;
    },
    distance() {
      return Util.formatDistanceEN(this.shop.distance * 1000);
    },
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../style/font.less";
@import "../style/common.less";

.shop {
  box-sizing: border-box;
  margin: 0 30px;
  padding: 30px 0;
  border-bottom: 1px solid @lightgrey;
  display: flex;

  .logo {
    flex: none;
    width: 220px;
    height: 147px;
    overflow: hidden;
    margin-right: 10px;
    text-align: center;

    img {
      width: 220px;
      height: 147px;
      object-fit: contain;
    }
  }

  .info {
    flex: none;
    width: 460px;
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    line-height: 1;

    p {
      line-height: 1.2;
      margin: 0;
      color: @black;
      .font-normal();
    }

    .desc {
      margin-top: 20px;
      color: @grey;
      display: flex;
      .font-info();

      .stars {
        margin-right: 10px;
      }

      .distance {
        margin-left: auto;
      }
    }

    .credit {
      margin-top: 20px;
      color: @grey;
      .font-info();
    }
  }
}
</style>
